import React, { useCallback, useEffect, useMemo, useState } from "react";
import MainLayout from "../components/mainLayout";
import { api } from "../api";
import { ProjetosApi } from "../service/projetosApi";
import { showError, showInfo } from "../utils/toast";
import "../sass/pages/gestao-projetos.scss";

const STATUS_SOLICITACAO_LABEL = {
  PENDENTE_ANALISE: "Pendente análise",
  EM_ANALISE: "Em análise",
  AJUSTE_SOLICITADO: "Ajuste solicitado",
  APROVADO: "Aprovado",
  REPROVADO: "Reprovado",
  CONVERTIDO_PROJETO: "Convertido",
  CANCELADO: "Cancelado",
};

const STATUS_PROJETO_LABEL = {
  PENDENTE: "Pendente",
  EM_ANDAMENTO: "Em andamento",
  TESTE: "Para teste",
  REAJUSTE: "Reajuste",
  FINALIZADO: "Finalizado",
  CONCLUIDO: "Concluído",
  CANCELADO: "Cancelado",
  PAUSADO: "Pausado",
  TESTADO_APROVADO: "Testado aprovado",
  TESTADO_REPROVADO: "Testado reprovado",
  AGUARDANDO_RETORNO_CLIENTE: "Aguardando retorno do cliente",
};

const TIPO_PROJETO_LABEL = {
  PROJETO: "Projeto",
  MELHORIA: "Melhoria",
  CORRECAO: "Correção",
  INCIDENTE: "Incidente",
  URGENTE: "Urgente",
  DEBITO_TECNICO: "Débito técnico",
};

const PAPEL_LABEL = {
  RESPONSAVEL_PRINCIPAL: "Responsável principal",
  DESENVOLVEDOR: "Desenvolvedor",
  BACKEND: "Backend",
  FRONTEND: "Frontend",
  MOBILE: "Mobile",
  QA: "Qualidade / teste",
  ANALISTA: "Analista",
  APOIO: "Apoio",
};

const TIPO_BLOQUEIO_LABEL = {
  AGUARDANDO_CLIENTE: "Aguardando cliente",
  AGUARDANDO_ACESSO: "Aguardando acesso",
  AGUARDANDO_DEFINICAO: "Aguardando definição",
  AGUARDANDO_DESENVOLVEDOR: "Aguardando desenvolvedor",
  AGUARDANDO_TERCEIRO: "Aguardando terceiro",
  BLOQUEIO_TECNICO: "Bloqueio técnico",
  OUTRO: "Outro",
};

const PRIORIDADES = ["BAIXA", "MEDIA", "ALTA", "CRITICA"];
const PAPEIS = Object.keys(PAPEL_LABEL);
const TIPOS_BLOQUEIO = Object.keys(TIPO_BLOQUEIO_LABEL);
const STATUS_TAREFA = [
  "PENDENTE",
  "EM_ANDAMENTO",
  "PAUSADO",
  "TESTE",
  "REAJUSTE",
  "CONCLUIDO",
  "CANCELADO",
];

const ABAS_PROJETO = [
  ["visao", "Visão geral"],
  ["equipe", "Equipe"],
  ["tarefas", "Tarefas"],
  ["bloqueios", "Bloqueios"],
  ["tempo", "Tempo"],
  ["apontamentos", "Apontamentos"],
];

function getLoggedUserId() {
  const direto =
    sessionStorage.getItem("IdFuncionario") ||
    localStorage.getItem("IdFuncionario") ||
    sessionStorage.getItem("codFunc") ||
    localStorage.getItem("codFunc");

  if (direto) return Number(direto) || null;

  try {
    const raw = sessionStorage.getItem("user") || localStorage.getItem("user");
    if (!raw) return null;

    const user = JSON.parse(raw);
    return (
      Number(
        user?.IdFuncionario ||
          user?.idFuncionario ||
          user?.id ||
          user?.ID ||
          user?.codFunc
      ) || null
    );
  } catch {
    return null;
  }
}


function getLoggedUserName() {
  try {
    const raw = sessionStorage.getItem("user") || localStorage.getItem("user");
    const user = raw ? JSON.parse(raw) : {};

    return (
      sessionStorage.getItem("RazaoSocial") ||
      sessionStorage.getItem("Nome") ||
      sessionStorage.getItem("nome") ||
      localStorage.getItem("RazaoSocial") ||
      localStorage.getItem("Nome") ||
      user?.nome ||
      user?.Nome ||
      user?.usuario ||
      "Gestor"
    );
  } catch {
    return (
      sessionStorage.getItem("RazaoSocial") ||
      sessionStorage.getItem("Nome") ||
      localStorage.getItem("RazaoSocial") ||
      "Gestor"
    );
  }
}

function obterIniciais(nome) {
  const partes = String(nome || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (!partes.length) return "GT";

  return partes
    .slice(0, 2)
    .map((parte) => parte.charAt(0).toUpperCase())
    .join("");
}

function normalizarBusca(valor) {
  return String(valor || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
}

function formatarData(data) {
  if (!data) return "-";
  const d = new Date(data);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("pt-BR");
}

function formatarDataHora(data) {
  if (!data) return "-";
  const d = new Date(data);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleString("pt-BR");
}


function diasCorrendo(data) {
  if (!data) return 0;
  const inicio = new Date(data);
  if (Number.isNaN(inicio.getTime())) return 0;
  return Math.max(0, Math.floor((Date.now() - inicio.getTime()) / 86400000));
}

function diasAteHoje(data) {
  if (!data) return 0;
  const prazo = new Date(data);
  if (Number.isNaN(prazo.getTime())) return 0;
  return Math.max(0, Math.floor((Date.now() - prazo.getTime()) / 86400000));
}

function estaAtrasado(dataPrazo) {
  if (!dataPrazo) return false;
  const prazo = new Date(dataPrazo);
  if (Number.isNaN(prazo.getTime())) return false;
  return prazo < new Date();
}

function normalizarLista(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.dados)) return data.dados;
  return [];
}

function normalizarSetores(raw) {
  const lista = normalizarLista(raw);

  return Array.from(
    new Set(
      lista
        .map((x) =>
          typeof x === "string"
            ? x.trim()
            : String(
                x?.Setor ||
                  x?.Cargo ||
                  x?.Descricao ||
                  x?.descricao ||
                  x?.nome ||
                  ""
              ).trim()
        )
        .filter(Boolean)
    )
  );
}

function normalizarFuncionarios(raw) {
  const lista = normalizarLista(raw);

  return lista
    .map((f) => ({
      id: Number(f.IdFuncionario || f.id || f.ID || f.ID_FUNCIONARIO || 0),
      nome:
        f.Nome ||
        f.nome ||
        f.Usuario ||
        f.usuario ||
        f.NOME ||
        f.NOME_FUNCIONARIO ||
        f.NOME_COMPLETO ||
        `#${f.IdFuncionario || f.id || f.ID}`,
    }))
    .filter((f) => f.id);
}

function getFuncionarioNomeFromPayload(valor, fallback) {
  if (!valor) return fallback;
  if (typeof valor === "string") return valor;

  return (
    valor.Nome ||
    valor.nome ||
    valor.NOME ||
    valor.Usuario ||
    valor.usuario ||
    valor.NOME_FUNCIONARIO ||
    valor.NOME_COMPLETO ||
    fallback
  );
}

function numeroOuZero(valor) {
  const n = Number(valor);
  return Number.isFinite(n) ? n : 0;
}

function formatarDuracao(segundos) {
  const total = Math.max(0, Math.floor(Number(segundos) || 0));
  const horas = Math.floor(total / 3600);
  const minutos = Math.floor((total % 3600) / 60);
  const segs = total % 60;

  if (horas > 0) {
    return `${String(horas).padStart(2, "0")}:${String(minutos).padStart(
      2,
      "0"
    )}:${String(segs).padStart(2, "0")}`;
  }

  return `${String(minutos).padStart(2, "0")}:${String(segs).padStart(2, "0")}`;
}

function duracaoSessao(sessao, agora) {
  if (!sessao) return 0;
  if (sessao.DURACAO_SEGUNDOS !== null && sessao.DURACAO_SEGUNDOS !== undefined) {
    return numeroOuZero(sessao.DURACAO_SEGUNDOS);
  }

  const inicio = new Date(sessao.DT_INICIO).getTime();
  const fim = sessao.DT_FIM ? new Date(sessao.DT_FIM).getTime() : agora;
  if (!Number.isFinite(inicio) || !Number.isFinite(fim)) return 0;
  return Math.max(0, Math.floor((fim - inicio) / 1000));
}

function removerDuplicadosPorProjeto(lista) {
  const mapa = new Map();
  normalizarLista(lista).forEach((item) => {
    const id = Number(item?.ID_PROJETO || 0);
    if (!id) return;

    const atual = mapa.get(id);
    if (!atual) {
      mapa.set(id, item);
      return;
    }

    mapa.set(id, {
      ...atual,
      ...item,
      ID_DEV: atual.ID_DEV || item.ID_DEV,
      RESPONSAVEL_ID: atual.RESPONSAVEL_ID || item.RESPONSAVEL_ID,
      RESPONSAVEL_NOME: atual.RESPONSAVEL_NOME || item.RESPONSAVEL_NOME,
      FOCUS_ATIVO:
        numeroOuZero(atual.FOCUS_ATIVO) === 1 || numeroOuZero(item.FOCUS_ATIVO) === 1
          ? 1
          : 0,
    });
  });

  return Array.from(mapa.values());
}

function StatusProjeto({ status }) {
  return (
    <span className={`status ${String(status || "").toLowerCase()}`}>
      {STATUS_PROJETO_LABEL[status] || status || "-"}
    </span>
  );
}

function EmptyState({ children }) {
  return <div className="empty-state">{children}</div>;
}

export default function GestaoProjetos() {
  const gestorId = useMemo(() => getLoggedUserId(), []);
  const gestorNome = useMemo(() => getLoggedUserName(), []);
  const gestorIniciais = useMemo(() => obterIniciais(gestorNome), [gestorNome]);

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [projetosAbertos, setProjetosAbertos] = useState([]);

  const [solicitacoes, setSolicitacoes] = useState([]);
  const [statusFiltroSolicitacao, setStatusFiltroSolicitacao] =
    useState("PENDENTE_ANALISE");
  const [buscaSolicitacao, setBuscaSolicitacao] = useState("");
  const [buscaProjetoCritico, setBuscaProjetoCritico] = useState("");

  const [cargos, setCargos] = useState([]);
  const [funcionarios, setFuncionarios] = useState([]);
  const [loadingFuncionarios, setLoadingFuncionarios] = useState(false);

  const [modalSolicitacao, setModalSolicitacao] = useState(null);
  const [acaoSolicitacao, setAcaoSolicitacao] = useState(null);
  const [loadingSolicitacaoDetalhe, setLoadingSolicitacaoDetalhe] =
    useState(false);

  const [formAtribuicao, setFormAtribuicao] = useState({
    setor: "",
    devId: "",
    prioridade: "MEDIA",
    justificativa: "",
  });

  const [motivo, setMotivo] = useState("");
  const [processando, setProcessando] = useState(false);

  const [projetoDetalhe, setProjetoDetalhe] = useState(null);
  const [abaProjeto, setAbaProjeto] = useState("visao");
  const [comentariosProjeto, setComentariosProjeto] = useState([]);
  const [sessoesProjeto, setSessoesProjeto] = useState([]);
  const [comentarioTexto, setComentarioTexto] = useState("");
  const [loadingDetalhe, setLoadingDetalhe] = useState(false);
  const [postandoComentario, setPostandoComentario] = useState(false);
  const [processandoProjeto, setProcessandoProjeto] = useState(false);
  const [agora, setAgora] = useState(Date.now());

  const [funcionariosParticipante, setFuncionariosParticipante] = useState([]);
  const [loadingFuncionariosParticipante, setLoadingFuncionariosParticipante] =
    useState(false);
  const [formParticipante, setFormParticipante] = useState({
    setor: "",
    devId: "",
    papel: "DESENVOLVEDOR",
    responsavelPrincipal: false,
    podeMovimentar: true,
    justificativa: "",
  });

  const [formTarefa, setFormTarefa] = useState({
    titulo: "",
    descricao: "",
    responsavelId: "",
    estimativaH: "",
    dtPrevista: "",
  });

  const [formBloqueio, setFormBloqueio] = useState({
    tipoBloqueio: "OUTRO",
    idTarefa: "",
    motivo: "",
    proximaAcao: "",
    responsavelResolucaoId: "",
    dtProximaRevisao: "",
  });
  const [solucoesBloqueio, setSolucoesBloqueio] = useState({});

  const [nomesFuncionarios, setNomesFuncionarios] = useState({});

  function obterNomeFuncionario(id) {
    if (!id) return "-";
    return nomesFuncionarios[Number(id)] || `#${id}`;
  }

  const carregarNomesFuncionarios = useCallback(
    async (ids = []) => {
      const idsLimpos = Array.from(
        new Set(ids.map((id) => Number(id)).filter(Boolean))
      ).filter((id) => !nomesFuncionarios[id]);

      if (!idsLimpos.length) return;

      try {
        const { data: nomesData } = await api.get("/func/names", {
          params: { ids: idsLimpos.join(",") },
        });

        const mapa = nomesData?.map || nomesData || {};
        const normalizado = {};

        Object.entries(mapa).forEach(([id, valor]) => {
          normalizado[Number(id)] = getFuncionarioNomeFromPayload(
            valor,
            `#${id}`
          );
        });

        setNomesFuncionarios((prev) => ({ ...prev, ...normalizado }));
      } catch {
        const resultados = await Promise.allSettled(
          idsLimpos.map(async (id) => {
            const { data: funcionario } = await api.get(`/func/${id}`);
            return [id, getFuncionarioNomeFromPayload(funcionario, `#${id}`)];
          })
        );

        const fallback = {};
        resultados.forEach((resultado, index) => {
          const id = idsLimpos[index];
          fallback[id] =
            resultado.status === "fulfilled" ? resultado.value[1] : `#${id}`;
        });

        setNomesFuncionarios((prev) => ({ ...prev, ...fallback }));
      }
    },
    [nomesFuncionarios]
  );

  async function carregar(opcoes = {}) {
    const silencioso = opcoes?.silencioso === true;
    if (!silencioso) setLoading(true);

    try {
      const [dashboardResult, solicitacoesResult, projetosResult] =
        await Promise.allSettled([
          api.get("/ssw/projeto-solicitacoes/dashboard", {
            params: { horasSemAtualizacao: 24 },
          }),
          api.get("/ssw/projeto-solicitacoes", {
            params: {
              page: 1,
              limit: 50,
              status: statusFiltroSolicitacao || undefined,
              sort: "CREATED_AT:desc",
            },
          }),
          ProjetosApi.list({
            page: 1,
            limit: 200,
            openOnly: true,
            sort: "CREATED_AT:desc",
            include: "activity,counters",
          }),
        ]);

      let dashboard = null;
      let listaSolicitacoes = [];
      let listaProjetos = [];

      if (dashboardResult.status === "fulfilled") {
        dashboard = dashboardResult.value?.data || null;
        setData(dashboard);
      } else {
        console.error(
          "[GestaoProjetos.carregar.dashboard][ERR]",
          dashboardResult.reason?.response?.data || dashboardResult.reason
        );
        setData((prev) =>
          prev || {
            sucesso: false,
            resumoSolicitacoes: {},
            resumoProjetos: {},
            devs: [],
            projetosCriticos: [],
          }
        );

        if (!silencioso) {
          showError(
            dashboardResult.reason?.response?.data?.message ||
              "Falha ao carregar dashboard de projetos."
          );
        }
      }

      if (solicitacoesResult.status === "fulfilled") {
        const raw = solicitacoesResult.value?.data;
        listaSolicitacoes = normalizarLista(raw);
        setSolicitacoes(listaSolicitacoes);
      } else {
        console.error(
          "[GestaoProjetos.carregar.solicitacoes][ERR]",
          solicitacoesResult.reason?.response?.data || solicitacoesResult.reason
        );
        setSolicitacoes([]);

        if (!silencioso) {
          showError(
            solicitacoesResult.reason?.response?.data?.message ||
              "Falha ao carregar solicitações de projeto."
          );
        }
      }

      if (projetosResult.status === "fulfilled") {
        listaProjetos = normalizarLista(projetosResult.value?.data);
        setProjetosAbertos(listaProjetos);
      } else {
        console.error(
          "[GestaoProjetos.carregar.projetos][ERR]",
          projetosResult.reason?.response?.data || projetosResult.reason
        );
        setProjetosAbertos([]);

        if (!silencioso) {
          showError(
            projetosResult.reason?.response?.data?.message ||
              "Falha ao carregar carteira de projetos."
          );
        }
      }

      const criticos = dashboard?.projetosCriticos || [];
      await carregarNomesFuncionarios([
        ...criticos.map((p) => p.ID_DEV || p.RESPONSAVEL_ID),
        ...listaSolicitacoes.map((s) => s.SOLICITANTE_ID),
        ...listaProjetos.map((p) => p.RESPONSAVEL_PRINCIPAL_ID),
        ...listaProjetos.map((p) => p.GESTOR_PROJETO_ID),
      ]);
    } catch (e) {
      console.error("[GestaoProjetos.carregar][ERR_FATAL]", e);
      if (!silencioso) showError("Falha ao carregar gestão de projetos.");
    } finally {
      if (!silencioso) setLoading(false);
    }
  }

  async function carregarSetores() {
    try {
      const { data: setoresData } = await api.get("/setores");
      setCargos(normalizarSetores(setoresData));
    } catch (e) {
      console.error("[GestaoProjetos.carregarSetores][ERR]", e);
      showError("Falha ao carregar setores.");
    }
  }

  async function buscarFuncionariosPorSetor(setor) {
    if (!setor) return [];
    const { data: funcionariosData } = await api.get(
      `/func/setor/${encodeURIComponent(setor)}`,
      { params: { situacao: "Ativo", bloqueado: 0 } }
    );
    return normalizarFuncionarios(funcionariosData);
  }

  async function carregarFuncionariosPorSetor(setor) {
    if (!setor) {
      setFuncionarios([]);
      setFormAtribuicao((prev) => ({ ...prev, devId: "" }));
      return;
    }

    setLoadingFuncionarios(true);
    try {
      const lista = await buscarFuncionariosPorSetor(setor);
      setFuncionarios(lista);
      setFormAtribuicao((prev) => ({
        ...prev,
        devId: "",
      }));
    } catch (e) {
      console.error("[GestaoProjetos.carregarFuncionariosPorSetor][ERR]", e);
      showError("Falha ao carregar funcionários do setor.");
      setFuncionarios([]);
    } finally {
      setLoadingFuncionarios(false);
    }
  }

  async function carregarFuncionariosParticipantePorSetor(setor) {
    if (!setor) {
      setFuncionariosParticipante([]);
      setFormParticipante((prev) => ({ ...prev, devId: "" }));
      return;
    }

    setLoadingFuncionariosParticipante(true);
    try {
      const lista = await buscarFuncionariosPorSetor(setor);
      setFuncionariosParticipante(lista);
      setFormParticipante((prev) => ({
        ...prev,
        devId: lista.length === 1 ? String(lista[0].id) : "",
      }));
    } catch (e) {
      console.error(
        "[GestaoProjetos.carregarFuncionariosParticipantePorSetor][ERR]",
        e
      );
      showError("Falha ao carregar funcionários do setor.");
      setFuncionariosParticipante([]);
    } finally {
      setLoadingFuncionariosParticipante(false);
    }
  }

  useEffect(() => {
    carregar();
    carregarSetores();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusFiltroSolicitacao]);

  useEffect(() => {
    const possuiAtiva = Boolean(projetoDetalhe?.sessoesAtivas?.length);
    if (!possuiAtiva) return undefined;

    const timer = window.setInterval(() => setAgora(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [projetoDetalhe?.ID_PROJETO, projetoDetalhe?.sessoesAtivas?.length]);

  async function abrirModalSolicitacao(solicitacao, acao = "visualizar") {
    if (!solicitacao?.ID_SOLICITACAO) return;
    setLoadingSolicitacaoDetalhe(true);

    try {
      const { data: detalheData } = await api.get(
        `/ssw/projeto-solicitacoes/${solicitacao.ID_SOLICITACAO}`
      );
      const detalhe = detalheData || solicitacao;

      setModalSolicitacao(detalhe);
      setAcaoSolicitacao(acao);
      setMotivo("");
      setFuncionarios([]);
      setFormAtribuicao({
        setor: "",
        devId: "",
        prioridade: detalhe?.PRIORIDADE_SOLICITADA || "MEDIA",
        justificativa: "",
      });
      await carregarNomesFuncionarios([detalhe?.SOLICITANTE_ID]);
    } catch (e) {
      console.error("[GestaoProjetos.abrirModalSolicitacao][ERR]", e);
      setModalSolicitacao(solicitacao);
      setAcaoSolicitacao(acao);
      setMotivo("");
      setFuncionarios([]);
      setFormAtribuicao({
        setor: "",
        devId: "",
        prioridade: solicitacao?.PRIORIDADE_SOLICITADA || "MEDIA",
        justificativa: "",
      });
      showError(
        e?.response?.data?.message ||
          "Falha ao carregar detalhes da solicitação. Exibindo dados da listagem."
      );
    } finally {
      setLoadingSolicitacaoDetalhe(false);
    }
  }

  function fecharModalSolicitacao() {
    setModalSolicitacao(null);
    setAcaoSolicitacao(null);
    setMotivo("");
    setFuncionarios([]);
    setFormAtribuicao({
      setor: "",
      devId: "",
      prioridade: "MEDIA",
      justificativa: "",
    });
  }

  async function aprovarSolicitacao(solicitacao) {
    setProcessando(true);
    try {
      await api.post(
        `/ssw/projeto-solicitacoes/${solicitacao.ID_SOLICITACAO}/aprovar`,
        {
          autorId: gestorId || undefined,
          motivo: motivo || "Solicitação aprovada pela gestão.",
        }
      );
      showInfo("Solicitação aprovada.");
      fecharModalSolicitacao();
      await carregar({ silencioso: true });
    } catch (e) {
      console.error("[GestaoProjetos.aprovarSolicitacao][ERR]", e);
      showError(e?.response?.data?.message || "Falha ao aprovar solicitação.");
    } finally {
      setProcessando(false);
    }
  }

  async function reprovarSolicitacao(solicitacao) {
    if (!motivo.trim()) {
      showError("Informe o motivo da reprovação.");
      return;
    }

    setProcessando(true);
    try {
      await api.post(
        `/ssw/projeto-solicitacoes/${solicitacao.ID_SOLICITACAO}/reprovar`,
        { autorId: gestorId || undefined, motivo: motivo.trim() }
      );
      showInfo("Solicitação reprovada.");
      fecharModalSolicitacao();
      await carregar({ silencioso: true });
    } catch (e) {
      console.error("[GestaoProjetos.reprovarSolicitacao][ERR]", e);
      showError(e?.response?.data?.message || "Falha ao reprovar solicitação.");
    } finally {
      setProcessando(false);
    }
  }

  async function solicitarAjuste(solicitacao) {
    if (!motivo.trim()) {
      showError("Informe o ajuste necessário.");
      return;
    }

    setProcessando(true);
    try {
      await api.post(
        `/ssw/projeto-solicitacoes/${solicitacao.ID_SOLICITACAO}/ajustar`,
        { autorId: gestorId || undefined, motivo: motivo.trim() }
      );
      showInfo("Ajuste solicitado.");
      fecharModalSolicitacao();
      await carregar({ silencioso: true });
    } catch (e) {
      console.error("[GestaoProjetos.solicitarAjuste][ERR]", e);
      showError(e?.response?.data?.message || "Falha ao solicitar ajuste.");
    } finally {
      setProcessando(false);
    }
  }

  async function converterEAtribuir(solicitacao) {
    const devId = Number(formAtribuicao.devId || 0);
    const gestorProjetoId = Number(gestorId || 0) || null;

    if (!devId) {
      showError("Selecione o responsável pelo projeto.");
      return;
    }

    const justificativa =
      formAtribuicao.justificativa?.trim() ||
      `Projeto convertido da solicitação #${solicitacao.ID_SOLICITACAO}`;

    const payload = {
      createdBy: gestorProjetoId || undefined,
      gestorProjetoId: gestorProjetoId || undefined,
      atribuir: true,
      devId,
      responsavelPrincipalId: devId,
      participantes: [
        {
          devId,
          papel: "RESPONSAVEL_PRINCIPAL",
          responsavelPrincipal: true,
          podeMovimentar: true,
          justificativa,
        },
      ],
      prioridade:
        formAtribuicao.prioridade ||
        solicitacao.PRIORIDADE_SOLICITADA ||
        "MEDIA",
      status: "PENDENTE",
      tipoProjeto: "PROJETO",
      justificativa,
      tarefas: [],
    };

    setProcessando(true);

    try {
      const { data: conversao } = await api.post(
        `/ssw/projeto-solicitacoes/${solicitacao.ID_SOLICITACAO}/converter`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      await carregarNomesFuncionarios([devId]);

      if (conversao?.possuiAvisos) {
        const avisos = conversao?.configuracao?.avisos || [];
        const resumoAvisos = avisos
          .map((aviso) => String(aviso || "").trim())
          .filter(Boolean)
          .join(" | ");

        showInfo(
          `Solicitação convertida no projeto #${
            conversao?.projeto?.ID_PROJETO || "-"
          }.`
        );

        showError(
          resumoAvisos ||
            `${avisos.length} aviso(s) foram retornados durante a configuração.`
        );

        console.warn(
          "[GestaoProjetos.converterEAtribuir][AVISOS]",
          avisos
        );
      } else {
        showInfo(
          conversao?.projeto?.ID_PROJETO
            ? `Solicitação convertida no projeto #${conversao.projeto.ID_PROJETO}.`
            : "Solicitação convertida e atribuída."
        );
      }

      fecharModalSolicitacao();
      await carregar({ silencioso: true });
    } catch (e) {
      const resposta = e?.response?.data || {};
      const detalhes = resposta?.details;

      console.error("[GestaoProjetos.converterEAtribuir][ERR]", {
        status: e?.response?.status,
        resposta,
        payload,
        erro: e,
      });

      const mensagemDetalhes = Array.isArray(detalhes)
        ? detalhes
            .map((item) => item?.message || item)
            .filter(Boolean)
            .join(" | ")
        : "";

      const codigo = resposta?.code ? ` [${resposta.code}]` : "";

      showError(
        `${
          mensagemDetalhes ||
          resposta?.message ||
          "Falha ao converter solicitação em projeto."
        }${codigo}`
      );
    } finally {
      setProcessando(false);
    }
  }

  function resetarFormulariosProjeto() {
    setAbaProjeto("visao");
    setFuncionariosParticipante([]);
    setFormParticipante({
      setor: "",
      devId: "",
      papel: "DESENVOLVEDOR",
      responsavelPrincipal: false,
      podeMovimentar: true,
      justificativa: "",
    });
    setFormTarefa({
      titulo: "",
      descricao: "",
      responsavelId: "",
      estimativaH: "",
      dtPrevista: "",
    });
    setFormBloqueio({
      tipoBloqueio: "OUTRO",
      idTarefa: "",
      motivo: "",
      proximaAcao: "",
      responsavelResolucaoId: "",
      dtProximaRevisao: "",
    });
    setSolucoesBloqueio({});
    setComentarioTexto("");
  }

  async function carregarProjetoDetalhe(idProjeto, opcoes = {}) {
    const mostrarLoading = opcoes?.mostrarLoading !== false;
    if (mostrarLoading) setLoadingDetalhe(true);

    try {
      const [projetoRes, comentariosRes, sessoesRes] = await Promise.all([
        ProjetosApi.get(idProjeto),
        ProjetosApi.listarComentarios(idProjeto),
        ProjetosApi.listarSessoesTrabalho({ idProjeto, limit: 500 }),
      ]);

      const projeto = projetoRes?.data || null;
      const comentarios = normalizarLista(comentariosRes?.data);
      const sessoes = normalizarLista(sessoesRes?.data);

      setProjetoDetalhe(projeto);
      setComentariosProjeto(comentarios);
      setSessoesProjeto(sessoes);
      setAgora(Date.now());

      const ids = [
        projeto?.CREATED_BY,
        projeto?.GESTOR_PROJETO_ID,
        projeto?.FORMALIZADO_BY,
        projeto?.SOLICITANTE_INTERRUPCAO_ID,
        ...(projeto?.atribuidos || []).map((a) => a.ID_DEV),
        ...(projeto?.tarefas || []).map((t) => t.RESPONSAVEL_ID),
        ...(projeto?.bloqueios || []).flatMap((b) => [
          b.RESPONSAVEL_RESOLUCAO_ID,
          b.CREATED_BY,
          b.RESOLVIDO_BY,
        ]),
        ...sessoes.map((s) => s.ID_DEV),
        ...comentarios.map((c) => c.AUTOR_ID),
      ];

      await carregarNomesFuncionarios(ids);
      return projeto;
    } catch (e) {
      console.error("[GestaoProjetos.carregarProjetoDetalhe][ERR]", e);
      showError(e?.response?.data?.message || "Falha ao abrir projeto.");
      return null;
    } finally {
      if (mostrarLoading) setLoadingDetalhe(false);
    }
  }

  async function abrirProjeto(idProjeto) {
    resetarFormulariosProjeto();
    await carregarProjetoDetalhe(idProjeto);
  }

  function fecharProjeto() {
    setProjetoDetalhe(null);
    setComentariosProjeto([]);
    setSessoesProjeto([]);
    resetarFormulariosProjeto();
  }

  async function atualizarProjetoAberto(mensagem) {
    const idProjeto = projetoDetalhe?.ID_PROJETO;
    if (!idProjeto) return;

    await carregarProjetoDetalhe(idProjeto, { mostrarLoading: false });
    await carregar({ silencioso: true });
    if (mensagem) showInfo(mensagem);
  }

  async function incluirComentarioProjeto() {
    if (!projetoDetalhe?.ID_PROJETO) return;
    const texto = comentarioTexto.trim();
    if (!texto) {
      showError("Informe o apontamento.");
      return;
    }

    setPostandoComentario(true);
    const temp = {
      ID_COMENTARIO: `tmp-${Date.now()}`,
      TEXTO: texto,
      AUTOR_ID: gestorId || null,
      CREATED_AT: new Date().toISOString(),
      _optimistic: true,
    };

    setComentariosProjeto((prev) => [temp, ...prev]);
    setComentarioTexto("");

    try {
      const { data: comentario } = await ProjetosApi.incluirComentario(
        projetoDetalhe.ID_PROJETO,
        { texto, autorId: gestorId || undefined }
      );
      await carregarNomesFuncionarios([gestorId, comentario?.AUTOR_ID]);
      setComentariosProjeto((prev) =>
        prev.map((c) =>
          c.ID_COMENTARIO === temp.ID_COMENTARIO ? comentario : c
        )
      );
      showInfo("Apontamento registrado.");
      await carregar({ silencioso: true });
    } catch (e) {
      console.error("[GestaoProjetos.incluirComentarioProjeto][ERR]", e);
      setComentariosProjeto((prev) =>
        prev.filter((c) => c.ID_COMENTARIO !== temp.ID_COMENTARIO)
      );
      setComentarioTexto(texto);
      showError(e?.response?.data?.message || "Falha ao registrar apontamento.");
    } finally {
      setPostandoComentario(false);
    }
  }

  async function adicionarParticipanteProjeto() {
    if (!projetoDetalhe?.ID_PROJETO) return;
    const devId = Number(formParticipante.devId || 0);
    if (!devId) {
      showError("Selecione o participante.");
      return;
    }

    setProcessandoProjeto(true);
    try {
      await ProjetosApi.adicionarParticipante(projetoDetalhe.ID_PROJETO, {
        devId,
        papel: formParticipante.papel,
        responsavelPrincipal: formParticipante.responsavelPrincipal,
        podeMovimentar: formParticipante.podeMovimentar,
        justificativa:
          formParticipante.justificativa.trim() ||
          "Participante incluído pela gestão.",
        autorId: gestorId || undefined,
      });

      setFormParticipante((prev) => ({
        ...prev,
        devId: "",
        justificativa: "",
        responsavelPrincipal: false,
      }));
      await atualizarProjetoAberto("Participante incluído no projeto.");
    } catch (e) {
      console.error("[GestaoProjetos.adicionarParticipanteProjeto][ERR]", e);
      showError(e?.response?.data?.message || "Falha ao incluir participante.");
    } finally {
      setProcessandoProjeto(false);
    }
  }

  async function atualizarParticipanteProjeto(devId, patch, mensagem) {
    if (!projetoDetalhe?.ID_PROJETO || !devId) return;
    setProcessandoProjeto(true);

    try {
      await ProjetosApi.atualizarParticipante(
        projetoDetalhe.ID_PROJETO,
        devId,
        {
          ...patch,
          justificativa: mensagem || "Participante atualizado pela gestão.",
          autorId: gestorId || undefined,
        }
      );
      await atualizarProjetoAberto(mensagem || "Participante atualizado.");
    } catch (e) {
      console.error("[GestaoProjetos.atualizarParticipanteProjeto][ERR]", e);
      showError(e?.response?.data?.message || "Falha ao atualizar participante.");
    } finally {
      setProcessandoProjeto(false);
    }
  }

  async function removerParticipanteProjeto(participante) {
    if (!projetoDetalhe?.ID_PROJETO || !participante?.ID_DEV) return;
    if (
      !window.confirm(
        `Remover ${obterNomeFuncionario(participante.ID_DEV)} deste projeto?`
      )
    ) {
      return;
    }

    setProcessandoProjeto(true);
    try {
      await ProjetosApi.removerParticipante(
        projetoDetalhe.ID_PROJETO,
        participante.ID_DEV,
        {
          justificativa: "Participante removido pela gestão.",
          autorId: gestorId || undefined,
        }
      );
      await atualizarProjetoAberto("Participante removido do projeto.");
    } catch (e) {
      console.error("[GestaoProjetos.removerParticipanteProjeto][ERR]", e);
      showError(e?.response?.data?.message || "Falha ao remover participante.");
    } finally {
      setProcessandoProjeto(false);
    }
  }

  async function criarTarefaProjeto() {
    if (!projetoDetalhe?.ID_PROJETO) return;
    if (!formTarefa.titulo.trim()) {
      showError("Informe o título da tarefa.");
      return;
    }

    setProcessandoProjeto(true);
    try {
      await ProjetosApi.criarTarefa(projetoDetalhe.ID_PROJETO, {
        titulo: formTarefa.titulo.trim(),
        descricao: formTarefa.descricao.trim() || null,
        responsavelId: Number(formTarefa.responsavelId) || null,
        estimativaH:
          formTarefa.estimativaH === "" ? null : Number(formTarefa.estimativaH),
        dtPrevista: formTarefa.dtPrevista || null,
      });

      setFormTarefa({
        titulo: "",
        descricao: "",
        responsavelId: "",
        estimativaH: "",
        dtPrevista: "",
      });
      await atualizarProjetoAberto("Tarefa criada.");
    } catch (e) {
      console.error("[GestaoProjetos.criarTarefaProjeto][ERR]", e);
      showError(e?.response?.data?.message || "Falha ao criar tarefa.");
    } finally {
      setProcessandoProjeto(false);
    }
  }

  async function atualizarTarefaProjeto(idTarefa, patch, mensagem) {
    if (!projetoDetalhe?.ID_PROJETO || !idTarefa) return;
    setProcessandoProjeto(true);

    try {
      await ProjetosApi.atualizarTarefa(
        projetoDetalhe.ID_PROJETO,
        idTarefa,
        patch
      );
      await atualizarProjetoAberto(mensagem || "Tarefa atualizada.");
    } catch (e) {
      console.error("[GestaoProjetos.atualizarTarefaProjeto][ERR]", e);
      showError(e?.response?.data?.message || "Falha ao atualizar tarefa.");
    } finally {
      setProcessandoProjeto(false);
    }
  }

  async function criarBloqueioProjeto() {
    if (!projetoDetalhe?.ID_PROJETO) return;
    if (!formBloqueio.motivo.trim()) {
      showError("Informe o motivo do bloqueio.");
      return;
    }

    setProcessandoProjeto(true);
    try {
      await ProjetosApi.criarBloqueio(projetoDetalhe.ID_PROJETO, {
        tipoBloqueio: formBloqueio.tipoBloqueio,
        idTarefa: Number(formBloqueio.idTarefa) || null,
        motivo: formBloqueio.motivo.trim(),
        proximaAcao: formBloqueio.proximaAcao.trim() || null,
        responsavelResolucaoId:
          Number(formBloqueio.responsavelResolucaoId) || null,
        dtProximaRevisao: formBloqueio.dtProximaRevisao || null,
        createdBy: gestorId || 0,
      });

      setFormBloqueio({
        tipoBloqueio: "OUTRO",
        idTarefa: "",
        motivo: "",
        proximaAcao: "",
        responsavelResolucaoId: "",
        dtProximaRevisao: "",
      });
      await atualizarProjetoAberto("Bloqueio registrado.");
    } catch (e) {
      console.error("[GestaoProjetos.criarBloqueioProjeto][ERR]", e);
      showError(e?.response?.data?.message || "Falha ao registrar bloqueio.");
    } finally {
      setProcessandoProjeto(false);
    }
  }

  async function resolverBloqueioProjeto(bloqueio) {
    if (!projetoDetalhe?.ID_PROJETO || !bloqueio?.ID_BLOQUEIO) return;
    const solucao = String(solucoesBloqueio[bloqueio.ID_BLOQUEIO] || "").trim();
    if (!solucao) {
      showError("Informe a solução do bloqueio.");
      return;
    }

    setProcessandoProjeto(true);
    try {
      await ProjetosApi.resolverBloqueio(
        projetoDetalhe.ID_PROJETO,
        bloqueio.ID_BLOQUEIO,
        { solucao, resolvidoBy: gestorId || 0 }
      );
      setSolucoesBloqueio((prev) => ({
        ...prev,
        [bloqueio.ID_BLOQUEIO]: "",
      }));
      await atualizarProjetoAberto("Bloqueio resolvido.");
    } catch (e) {
      console.error("[GestaoProjetos.resolverBloqueioProjeto][ERR]", e);
      showError(e?.response?.data?.message || "Falha ao resolver bloqueio.");
    } finally {
      setProcessandoProjeto(false);
    }
  }

  async function formalizarProjetoProvisorio() {
    if (!projetoDetalhe?.ID_PROJETO) return;
    setProcessandoProjeto(true);

    try {
      await ProjetosApi.patch(projetoDetalhe.ID_PROJETO, {
        cadastroProvisorio: false,
        gestorProjetoId: gestorId || null,
      });
      await atualizarProjetoAberto("Incidente provisório formalizado.");
    } catch (e) {
      console.error("[GestaoProjetos.formalizarProjetoProvisorio][ERR]", e);
      showError(e?.response?.data?.message || "Falha ao formalizar projeto.");
    } finally {
      setProcessandoProjeto(false);
    }
  }

  async function assumirGestaoProjeto() {
    if (!projetoDetalhe?.ID_PROJETO || !gestorId) return;
    setProcessandoProjeto(true);

    try {
      await ProjetosApi.patch(projetoDetalhe.ID_PROJETO, {
        gestorProjetoId: gestorId,
      });
      await atualizarProjetoAberto("Gestão do projeto atualizada.");
    } catch (e) {
      console.error("[GestaoProjetos.assumirGestaoProjeto][ERR]", e);
      showError(e?.response?.data?.message || "Falha ao assumir gestão.");
    } finally {
      setProcessandoProjeto(false);
    }
  }

  const resumoSolicitacoes = data?.resumoSolicitacoes || {};
  const resumoProjetos = data?.resumoProjetos || {};
  const projetosCriticos = removerDuplicadosPorProjeto(
    data?.projetosCriticos || []
  );
  const mapaProjetosAbertos = new Map(
    projetosAbertos.map((projeto) => [Number(projeto.ID_PROJETO), projeto])
  );

  const metricasColaborativas = {
    trabalhando: projetosAbertos.filter(
      (p) => numeroOuZero(p.QT_SESSOES_ATIVAS) > 0
    ).length,
    colaborativos: projetosAbertos.filter(
      (p) => numeroOuZero(p.QT_PARTICIPANTES) > 1
    ).length,
    provisorios: projetosAbertos.filter(
      (p) => Boolean(p.CADASTRO_PROVISORIO)
    ).length,
    pausados: projetosAbertos.filter((p) => p.STATUS === "PAUSADO").length,
    semAtualizacao: projetosAbertos.filter((p) => {
      const referencia = p.LAST_ACTIVITY_AT || p.CREATED_AT;
      return diasCorrendo(referencia) >= 1;
    }).length,
  };

  const projetosSemAndamento = projetosAbertos
    .filter((p) => {
      const semSessao = numeroOuZero(p.QT_SESSOES_ATIVAS) === 0;
      const parado = p.STATUS === "PAUSADO" || diasCorrendo(p.LAST_ACTIVITY_AT || p.CREATED_AT) >= 2;
      return semSessao && parado;
    })
    .sort(
      (a, b) =>
        diasCorrendo(b.LAST_ACTIVITY_AT || b.CREATED_AT) -
        diasCorrendo(a.LAST_ACTIVITY_AT || a.CREATED_AT)
    )
    .slice(0, 8);

  const incidentesProvisorios = projetosAbertos
    .filter((p) => Boolean(p.CADASTRO_PROVISORIO))
    .sort(
      (a, b) => new Date(a.CREATED_AT).getTime() - new Date(b.CREATED_AT).getTime()
    )
    .slice(0, 8);

  const participantesAtivos = (projetoDetalhe?.atribuidos || []).filter(
    (a) => a.ATIVO !== false && numeroOuZero(a.ATIVO) !== 0
  );
  const bloqueiosAbertos = (projetoDetalhe?.bloqueios || []).filter(
    (b) => b.STATUS_BLOQUEIO === "ABERTO"
  );
  const responsavelPrincipal = participantesAtivos.find(
    (a) => Boolean(a.RESPONSAVEL_PRINCIPAL)
  );

  const termoSolicitacao = normalizarBusca(buscaSolicitacao);
  const solicitacoesFiltradas = termoSolicitacao
    ? solicitacoes.filter((solicitacao) =>
        normalizarBusca(
          [
            solicitacao.ID_SOLICITACAO,
            solicitacao.TITULO,
            solicitacao.DESCRICAO_PROBLEMA,
            solicitacao.SOLICITANTE_NOME,
            obterNomeFuncionario(solicitacao.SOLICITANTE_ID),
            solicitacao.PRIORIDADE_SOLICITADA,
          ].join(" ")
        ).includes(termoSolicitacao)
      )
    : solicitacoes;

  const termoProjetoCritico = normalizarBusca(buscaProjetoCritico);
  const projetosCriticosFiltrados = termoProjetoCritico
    ? projetosCriticos.filter((projeto) => {
        const enriquecido =
          mapaProjetosAbertos.get(Number(projeto.ID_PROJETO)) || {};
        const responsavelId =
          enriquecido.RESPONSAVEL_PRINCIPAL_ID ||
          projeto.ID_DEV ||
          projeto.RESPONSAVEL_ID;

        return normalizarBusca(
          [
            projeto.ID_PROJETO,
            projeto.CODIGO,
            projeto.TITULO,
            projeto.STATUS,
            projeto.PRIORIDADE,
            projeto.RESPONSAVEL_NOME,
            obterNomeFuncionario(responsavelId),
          ].join(" ")
        ).includes(termoProjetoCritico);
      })
    : projetosCriticos;

  const ultimaAtualizacao = data
    ? new Date().toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
      })
    : null;

  if (loading && !data) {
    return (
      <MainLayout>
        <div className="gestao gestao-loading">
          <div className="loading-card">Carregando gestão de projetos...</div>
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="gestao">
        <header className="gestao-header gestao-hero">
          <div className="hero-copy">
            <span className="page-eyebrow">Central de operação</span>
            <h1>Gestão de projetos</h1>
            <p>
              Uma visão única para analisar demandas, acompanhar execução,
              remover impedimentos e orientar a equipe.
            </p>

            <div className="hero-context">
              <span className="context-dot" aria-hidden="true" />
              <span>
                {ultimaAtualizacao
                  ? `Dados atualizados às ${ultimaAtualizacao}`
                  : "Aguardando primeira atualização"}
              </span>
              <span className="context-separator" aria-hidden="true" />
              <span>{projetosAbertos.length} projeto(s) na carteira aberta</span>
            </div>
          </div>

          <div className="hero-actions">
            <div className="gestor-chip">
              <span className="gestor-avatar" aria-hidden="true">
                {gestorIniciais}
              </span>
              <span className="gestor-copy">
                <small>Gestor conectado</small>
                <strong>{gestorNome}</strong>
              </span>
            </div>

            <button
              className="btn-refresh"
              type="button"
              onClick={() => carregar()}
              disabled={loading}
            >
              <span
                className={`refresh-symbol ${loading ? "is-spinning" : ""}`}
                aria-hidden="true"
              >
                ↻
              </span>
              {loading ? "Atualizando..." : "Atualizar dados"}
            </button>
          </div>
        </header>

        <section className="gestao-kpis" aria-label="Indicadores principais">
          <article className="kpi warning">
            <div className="metric-head">
              <span className="metric-icon" aria-hidden="true">S</span>
              <span className="metric-state">Ação necessária</span>
            </div>
            <span className="metric-label">Solicitações pendentes</span>
            <strong>{resumoSolicitacoes.pendentesAnalise || 0}</strong>
            <small>Aguardando análise da gestão</small>
          </article>

          <article className="kpi success">
            <div className="metric-head">
              <span className="metric-icon" aria-hidden="true">A</span>
              <span className="metric-state">Prontas</span>
            </div>
            <span className="metric-label">Aprovadas não convertidas</span>
            <strong>{resumoSolicitacoes.aprovadasNaoConvertidas || 0}</strong>
            <small>Podem ser transformadas em projeto</small>
          </article>

          <article className="kpi info">
            <div className="metric-head">
              <span className="metric-icon" aria-hidden="true">P</span>
              <span className="metric-state">Carteira</span>
            </div>
            <span className="metric-label">Projetos ativos</span>
            <strong>{resumoProjetos.totalProjetos || projetosAbertos.length}</strong>
            <small>Entregas sob acompanhamento</small>
          </article>

          <article className="kpi danger">
            <div className="metric-head">
              <span className="metric-icon" aria-hidden="true">!</span>
              <span className="metric-state">Risco</span>
            </div>
            <span className="metric-label">Projetos atrasados</span>
            <strong>{resumoProjetos.atrasados || 0}</strong>
            <small>Exigem decisão ou follow-up</small>
          </article>
        </section>

        <section
          className="gestao-collab-kpis"
          aria-label="Indicadores operacionais"
        >
          <article className="collab-kpi running">
            <span className="collab-icon" aria-hidden="true">▶</span>
            <div>
              <span>Trabalhando agora</span>
              <strong>{metricasColaborativas.trabalhando}</strong>
              <small>Projetos com sessão ativa</small>
            </div>
          </article>

          <article className="collab-kpi team">
            <span className="collab-icon" aria-hidden="true">◆</span>
            <div>
              <span>Colaborativos</span>
              <strong>{metricasColaborativas.colaborativos}</strong>
              <small>Mais de um participante</small>
            </div>
          </article>

          <article className="collab-kpi urgent">
            <span className="collab-icon" aria-hidden="true">!</span>
            <div>
              <span>Incidentes provisórios</span>
              <strong>{metricasColaborativas.provisorios}</strong>
              <small>Precisam ser formalizados</small>
            </div>
          </article>

          <article className="collab-kpi paused">
            <span className="collab-icon" aria-hidden="true">Ⅱ</span>
            <div>
              <span>Pausados</span>
              <strong>{metricasColaborativas.pausados}</strong>
              <small>Sem execução corrente</small>
            </div>
          </article>

          <article className="collab-kpi stale">
            <span className="collab-icon" aria-hidden="true">◷</span>
            <div>
              <span>Sem atualização 24h</span>
              <strong>{metricasColaborativas.semAtualizacao}</strong>
              <small>Cobrança recomendada</small>
            </div>
          </article>
        </section>

        <div className="gestao-followup-grid">
          <section className="gestao-card followup-card">
            <div className="card-header">
              <div>
                <h2>Projetos parados</h2>
                <p>Pausados ou sem movimentação recente e sem sessão ativa.</p>
              </div>
              <span className="header-count">{projetosSemAndamento.length}</span>
            </div>

            <div className="followup-list">
              {projetosSemAndamento.length === 0 && (
                <EmptyState>Nenhum projeto parado para cobrança.</EmptyState>
              )}
              {projetosSemAndamento.map((p) => (
                <button
                  key={p.ID_PROJETO}
                  type="button"
                  className="followup-item"
                  onClick={() => abrirProjeto(p.ID_PROJETO)}
                >
                  <div>
                    <strong>{p.TITULO}</strong>
                    <span>{p.CODIGO || `#${p.ID_PROJETO}`}</span>
                  </div>
                  <small>
                    {diasCorrendo(p.LAST_ACTIVITY_AT || p.CREATED_AT)}d sem atividade
                  </small>
                </button>
              ))}
            </div>
          </section>

          <section className="gestao-card followup-card urgent-card">
            <div className="card-header">
              <div>
                <h2>Urgências provisórias</h2>
                <p>Incidentes abertos rapidamente que precisam de escopo e gestão.</p>
              </div>
              <span className="header-count">{incidentesProvisorios.length}</span>
            </div>

            <div className="followup-list">
              {incidentesProvisorios.length === 0 && (
                <EmptyState>Nenhum incidente provisório pendente.</EmptyState>
              )}
              {incidentesProvisorios.map((p) => (
                <button
                  key={p.ID_PROJETO}
                  type="button"
                  className="followup-item"
                  onClick={() => abrirProjeto(p.ID_PROJETO)}
                >
                  <div>
                    <strong>{p.TITULO}</strong>
                    <span>{p.CODIGO || `#${p.ID_PROJETO}`}</span>
                  </div>
                  <small>{diasCorrendo(p.CREATED_AT)}d provisório</small>
                </button>
              ))}
            </div>
          </section>
        </div>

        <div className="gestao-grid">
          <section className="gestao-card gestao-card-solicitacoes">
            <div className="card-header">
              <div className="card-heading-copy">
                <span className="section-eyebrow">Entrada de demandas</span>
                <h2>Solicitações de projeto</h2>
                <p>Analise o escopo, peça ajustes e transforme demandas aprovadas em projetos.</p>
              </div>

              <div className="card-tools">
                <label className="search-control">
                  <span aria-hidden="true">⌕</span>
                  <input
                    value={buscaSolicitacao}
                    onChange={(e) => setBuscaSolicitacao(e.target.value)}
                    placeholder="Buscar solicitação..."
                    aria-label="Buscar solicitação"
                  />
                  {buscaSolicitacao && (
                    <button
                      type="button"
                      onClick={() => setBuscaSolicitacao("")}
                      aria-label="Limpar busca"
                    >
                      ×
                    </button>
                  )}
                </label>

                <select
                  value={statusFiltroSolicitacao}
                  onChange={(e) => setStatusFiltroSolicitacao(e.target.value)}
                  aria-label="Filtrar solicitações por status"
                >
                  <option value="">Todos os status</option>
                  <option value="PENDENTE_ANALISE">Pendentes</option>
                  <option value="APROVADO">Aprovadas</option>
                  <option value="AJUSTE_SOLICITADO">Ajuste solicitado</option>
                  <option value="REPROVADO">Reprovadas</option>
                  <option value="CONVERTIDO_PROJETO">Convertidas</option>
                </select>
              </div>
            </div>

            <div className="list-summary">
              <span>
                Exibindo <strong>{solicitacoesFiltradas.length}</strong> de{" "}
                <strong>{solicitacoes.length}</strong> solicitação(ões)
              </span>
              {buscaSolicitacao && (
                <span className="active-filter">
                  Busca: “{buscaSolicitacao}”
                </span>
              )}
            </div>

            <div className="solicitacoes-list">
              {solicitacoesFiltradas.length === 0 && (
                <EmptyState>Nenhuma solicitação encontrada para os filtros atuais.</EmptyState>
              )}

              {solicitacoesFiltradas.map((s) => (
                <div key={s.ID_SOLICITACAO} className="solicitacao-item">
                  <div
                    className="solicitacao-main solicitacao-clickable"
                    role="button"
                    tabIndex={0}
                    onClick={() => abrirModalSolicitacao(s, "visualizar")}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") abrirModalSolicitacao(s, "visualizar");
                    }}
                    title="Abrir escopo da solicitação"
                  >
                    <div className="solicitacao-title-row">
                      <span className="request-id">#{s.ID_SOLICITACAO}</span>
                      <strong>{s.TITULO}</strong>
                      <span
                        className={`sol-status ${String(
                          s.STATUS_SOLICITACAO || ""
                        ).toLowerCase()}`}
                      >
                        {STATUS_SOLICITACAO_LABEL[s.STATUS_SOLICITACAO] ||
                          s.STATUS_SOLICITACAO}
                      </span>
                    </div>

                    <p>{s.DESCRICAO_PROBLEMA || "-"}</p>

                    <div className="solicitacao-meta">
                      <span>
                        Solicitante {s.SOLICITANTE_NOME || obterNomeFuncionario(s.SOLICITANTE_ID)}
                      </span>
                      <span>Criada em {formatarData(s.CREATED_AT)}</span>
                      <span>Prazo {formatarData(s.PRAZO_DESEJADO)}</span>
                      <span>Prioridade {s.PRIORIDADE_SOLICITADA || "-"}</span>
                    </div>
                  </div>

                  <div className="solicitacao-actions">
                    <button className="btn-outline" onClick={() => abrirModalSolicitacao(s, "visualizar")}>
                      Ver escopo
                    </button>

                    {(s.STATUS_SOLICITACAO === "PENDENTE_ANALISE" ||
                      s.STATUS_SOLICITACAO === "EM_ANALISE") && (
                      <>
                        <button className="btn-outline" onClick={() => abrirModalSolicitacao(s, "aprovar")}>
                          Aprovar
                        </button>
                        <button className="btn-outline" onClick={() => abrirModalSolicitacao(s, "ajustar")}>
                          Ajuste
                        </button>
                        <button className="btn-danger-outline" onClick={() => abrirModalSolicitacao(s, "reprovar")}>
                          Reprovar
                        </button>
                      </>
                    )}

                    {(s.STATUS_SOLICITACAO === "PENDENTE_ANALISE" ||
                      s.STATUS_SOLICITACAO === "EM_ANALISE" ||
                      s.STATUS_SOLICITACAO === "APROVADO") &&
                      !s.ID_PROJETO_GERADO && (
                        <button className="btn-primary" onClick={() => abrirModalSolicitacao(s, "converter")}>
                          Converter / atribuir
                        </button>
                      )}

                    {s.ID_PROJETO_GERADO && (
                      <button className="btn-primary" onClick={() => abrirProjeto(s.ID_PROJETO_GERADO)}>
                        Abrir projeto
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="gestao-card gestao-card-side">
            <div className="card-header">
              <div>
                <h2>Resumo operacional</h2>
                <p>Indicadores de acompanhamento diário.</p>
              </div>
            </div>

            <div className="side-metrics">
              <div className="side-metric">
                <span>Sem atualização</span>
                <strong>{resumoProjetos.semAtualizacao || metricasColaborativas.semAtualizacao}</strong>
              </div>
              <div className="side-metric">
                <span>Finalizados aguardando</span>
                <strong>{resumoProjetos.finalizadosAguardandoGestor || 0}</strong>
              </div>
              <div className="side-metric">
                <span>Em andamento</span>
                <strong>{resumoProjetos.emAndamento || 0}</strong>
              </div>
              <div className="side-metric">
                <span>Com foco</span>
                <strong>{resumoProjetos.comFoco || 0}</strong>
              </div>
              <div className="side-metric">
                <span>Em execução agora</span>
                <strong>{metricasColaborativas.trabalhando}</strong>
              </div>
              <div className="side-metric">
                <span>Colaborativos</span>
                <strong>{metricasColaborativas.colaborativos}</strong>
              </div>
            </div>
          </section>
        </div>

        <section className="gestao-card gestao-table-card">
          <div className="card-header">
            <div className="card-heading-copy">
              <span className="section-eyebrow">Acompanhamento executivo</span>
              <h2>Projetos que exigem atenção</h2>
              <p>Atrasos, falta de atualização, reajustes, testes e entregas aguardando validação.</p>
            </div>

            <div className="card-tools">
              <label className="search-control search-control-wide">
                <span aria-hidden="true">⌕</span>
                <input
                  value={buscaProjetoCritico}
                  onChange={(e) => setBuscaProjetoCritico(e.target.value)}
                  placeholder="Buscar projeto, código ou responsável..."
                  aria-label="Buscar projeto crítico"
                />
                {buscaProjetoCritico && (
                  <button
                    type="button"
                    onClick={() => setBuscaProjetoCritico("")}
                    aria-label="Limpar busca"
                  >
                    ×
                  </button>
                )}
              </label>
            </div>
          </div>

          <div className="list-summary">
            <span>
              <strong>{projetosCriticosFiltrados.length}</strong> projeto(s) exibido(s)
            </span>
            <span className="summary-hint">
              Ordenados por atraso, inatividade e prazo
            </span>
          </div>

          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Projeto</th>
                  <th>Responsável</th>
                  <th>Equipe</th>
                  <th>Execução</th>
                  <th>Prazo</th>
                  <th>SLA</th>
                  <th>Última atualização</th>
                  <th>Status</th>
                  <th>Alertas</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {projetosCriticosFiltrados.length === 0 && (
                  <tr>
                    <td colSpan={11}>
                      <div className="empty-state table-empty">Nenhum projeto crítico no momento.</div>
                    </td>
                  </tr>
                )}

                {projetosCriticosFiltrados.map((p) => {
                  const enriquecido = mapaProjetosAbertos.get(Number(p.ID_PROJETO)) || {};
                  const projetoAtrasado = estaAtrasado(p.DT_PREVISTA);
                  const semAtualizacao = Number(p.SEM_ATUALIZACAO) === 1;
                  const diasAtraso = diasAteHoje(p.DT_PREVISTA);
                  const responsavelId =
                    enriquecido.RESPONSAVEL_PRINCIPAL_ID || p.ID_DEV || p.RESPONSAVEL_ID;

                  return (
                    <tr key={p.ID_PROJETO} className={projetoAtrasado || semAtualizacao ? "danger-row" : ""}>
                      <td>{p.CODIGO || `#${p.ID_PROJETO}`}</td>
                      <td className="titulo">
                        <strong>{p.TITULO}</strong>
                        <small>#{p.ID_PROJETO}</small>
                      </td>
                      <td className="responsavel">{p.RESPONSAVEL_NOME || obterNomeFuncionario(responsavelId)}</td>
                      <td>
                        <span className="tag info">{numeroOuZero(enriquecido.QT_PARTICIPANTES) || 1} pessoa(s)</span>
                      </td>
                      <td>
                        {numeroOuZero(enriquecido.QT_SESSOES_ATIVAS) > 0 ? (
                          <span className="tag ok">Em execução</span>
                        ) : (
                          <span className="tag warning">Sem sessão</span>
                        )}
                      </td>
                      <td>{formatarData(p.DT_PREVISTA)}</td>
                      <td>
                        <span className={`tag ${projetoAtrasado ? "danger" : "ok"}`}>
                          {projetoAtrasado ? `${diasAtraso}d atraso` : `${diasCorrendo(p.CREATED_AT || p.DT_INICIO)}d`}
                        </span>
                      </td>
                      <td>{formatarDataHora(p.LAST_UPDATE_AT || enriquecido.LAST_ACTIVITY_AT)}</td>
                      <td><StatusProjeto status={p.STATUS} /></td>
                      <td>
                        <div className="alert-tags">
                          {projetoAtrasado && <span className="tag danger">Atrasado</span>}
                          {semAtualizacao && <span className="tag warning">Sem atualização</span>}
                          {Number(p.FOCUS_ATIVO) === 1 && <span className="tag info">Foco</span>}
                          {Boolean(enriquecido.CADASTRO_PROVISORIO) && <span className="tag danger">Provisório</span>}
                        </div>
                      </td>
                      <td>
                        <button className="btn-primary" onClick={() => abrirProjeto(p.ID_PROJETO)}>
                          Acompanhar
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </section>

        {modalSolicitacao && (
          <div className="gestao-modal-backdrop" onClick={fecharModalSolicitacao}>
            <div className={`gestao-modal ${acaoSolicitacao === "visualizar" ? "solicitacao-modal" : ""}`} onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <div>
                  <h2>
                    {acaoSolicitacao === "converter"
                      ? "Converter solicitação em projeto"
                      : acaoSolicitacao === "aprovar"
                      ? "Aprovar solicitação"
                      : acaoSolicitacao === "ajustar"
                      ? "Solicitar ajuste"
                      : acaoSolicitacao === "reprovar"
                      ? "Reprovar solicitação"
                      : "Escopo da solicitação"}
                  </h2>
                  <p>{modalSolicitacao.TITULO}</p>
                </div>
                <button className="btn-close" onClick={fecharModalSolicitacao}>Fechar</button>
              </div>

              <div className="modal-body">
                <div className="escopo-box">
                  <div className="escopo-header">
                    <div>
                      <h3>Escopo</h3>
                      <p>
                        Solicitação #{modalSolicitacao.ID_SOLICITACAO} • {STATUS_SOLICITACAO_LABEL[modalSolicitacao.STATUS_SOLICITACAO] || modalSolicitacao.STATUS_SOLICITACAO}
                      </p>
                    </div>
                    <div className="escopo-meta">
                      <span>Solicitante {modalSolicitacao.SOLICITANTE_NOME || obterNomeFuncionario(modalSolicitacao.SOLICITANTE_ID)}</span>
                      <span>Criada em {formatarDataHora(modalSolicitacao.CREATED_AT)}</span>
                      <span>Prazo {formatarData(modalSolicitacao.PRAZO_DESEJADO)}</span>
                      <span>Prioridade {modalSolicitacao.PRIORIDADE_SOLICITADA || "-"}</span>
                    </div>
                  </div>

                  {loadingSolicitacaoDetalhe && <EmptyState>Carregando detalhes completos da solicitação...</EmptyState>}

                  <div className="escopo-grid">
                    {[
                      ["Problema", modalSolicitacao.DESCRICAO_PROBLEMA],
                      ["Objetivo", modalSolicitacao.OBJETIVO],
                      ["Impacto", modalSolicitacao.IMPACTO],
                      ["Regra de negócio", modalSolicitacao.REGRA_NEGOCIO],
                      ["Critério de aceite", modalSolicitacao.CRITERIO_ACEITE],
                      ["Observação", modalSolicitacao.OBSERVACAO],
                      ["Motivo da reprovação", modalSolicitacao.MOTIVO_REPROVACAO],
                      ["Motivo do ajuste", modalSolicitacao.MOTIVO_AJUSTE],
                    ]
                      .filter(([, valor], index) => index < 6 || Boolean(valor))
                      .map(([titulo, valor]) => (
                        <div key={titulo}>
                          <span>{titulo}</span>
                          <p>{valor || "-"}</p>
                        </div>
                      ))}
                  </div>
                </div>

                {acaoSolicitacao === "converter" && (
                  <div className="form-converter">
                    <div className="field">
                      <label>Setor</label>
                      <select
                        value={formAtribuicao.setor}
                        onChange={(e) => {
                          const setor = e.target.value;
                          setFormAtribuicao((prev) => ({ ...prev, setor, devId: "" }));
                          carregarFuncionariosPorSetor(setor);
                        }}
                      >
                        <option value="">Selecione</option>
                        {cargos.map((c) => <option key={c} value={c}>{c}</option>)}
                      </select>
                    </div>
                    <div className="field">
                      <label>Responsável</label>
                      <select
                        value={formAtribuicao.devId}
                        disabled={!formAtribuicao.setor || loadingFuncionarios}
                        onChange={(e) => setFormAtribuicao((prev) => ({ ...prev, devId: e.target.value }))}
                      >
                        <option value="">{loadingFuncionarios ? "Carregando..." : "Selecione"}</option>
                        {funcionarios.map((f) => <option key={f.id} value={f.id}>{f.nome}</option>)}
                      </select>
                    </div>
                    <div className="field">
                      <label>Prioridade</label>
                      <select value={formAtribuicao.prioridade} onChange={(e) => setFormAtribuicao((prev) => ({ ...prev, prioridade: e.target.value }))}>
                        {PRIORIDADES.map((p) => <option key={p} value={p}>{p}</option>)}
                      </select>
                    </div>
                    <div className="field field-full">
                      <label>Justificativa / orientação inicial</label>
                      <textarea rows={3} value={formAtribuicao.justificativa} onChange={(e) => setFormAtribuicao((prev) => ({ ...prev, justificativa: e.target.value }))} placeholder="Ex: Priorizar por impacto no cliente X..." />
                    </div>
                  </div>
                )}

                {acaoSolicitacao !== "converter" && acaoSolicitacao !== "visualizar" && (
                  <div className="field field-full">
                    <label>{acaoSolicitacao === "aprovar" ? "Observação" : acaoSolicitacao === "ajustar" ? "Ajuste necessário" : "Motivo da reprovação"}</label>
                    <textarea rows={4} value={motivo} onChange={(e) => setMotivo(e.target.value)} placeholder="Informe a observação para histórico..." />
                  </div>
                )}
              </div>

              <div className="modal-actions">
                <button className="btn-secondary" disabled={processando} onClick={fecharModalSolicitacao}>Cancelar</button>
                {acaoSolicitacao === "aprovar" && <button className="btn-primary" disabled={processando} onClick={() => aprovarSolicitacao(modalSolicitacao)}>{processando ? "Aprovando..." : "Aprovar"}</button>}
                {acaoSolicitacao === "ajustar" && <button className="btn-warning" disabled={processando} onClick={() => solicitarAjuste(modalSolicitacao)}>{processando ? "Enviando..." : "Solicitar ajuste"}</button>}
                {acaoSolicitacao === "reprovar" && <button className="btn-danger" disabled={processando} onClick={() => reprovarSolicitacao(modalSolicitacao)}>{processando ? "Reprovando..." : "Reprovar"}</button>}
                {acaoSolicitacao === "converter" && <button className="btn-primary" disabled={processando} onClick={() => converterEAtribuir(modalSolicitacao)}>{processando ? "Convertendo..." : "Converter e atribuir"}</button>}
                {acaoSolicitacao === "visualizar" && (
                  <>
                    {(modalSolicitacao.STATUS_SOLICITACAO === "PENDENTE_ANALISE" || modalSolicitacao.STATUS_SOLICITACAO === "EM_ANALISE") && (
                      <>
                        <button className="btn-outline" disabled={processando} onClick={() => setAcaoSolicitacao("aprovar")}>Aprovar</button>
                        <button className="btn-warning" disabled={processando} onClick={() => setAcaoSolicitacao("ajustar")}>Solicitar ajuste</button>
                        <button className="btn-danger" disabled={processando} onClick={() => setAcaoSolicitacao("reprovar")}>Reprovar</button>
                      </>
                    )}
                    {(modalSolicitacao.STATUS_SOLICITACAO === "PENDENTE_ANALISE" || modalSolicitacao.STATUS_SOLICITACAO === "EM_ANALISE" || modalSolicitacao.STATUS_SOLICITACAO === "APROVADO") && !modalSolicitacao.ID_PROJETO_GERADO && (
                      <button className="btn-primary" disabled={processando} onClick={() => setAcaoSolicitacao("converter")}>Converter / atribuir</button>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        {projetoDetalhe && (
          <div className="gestao-modal-backdrop projeto-backdrop" onClick={fecharProjeto}>
            <div className="gestao-modal projeto-modal projeto-modal-colaborativo" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header projeto-modal-header">
                <div className="projeto-header-main">
                  <div className="projeto-header-tags">
                    <span className="tag info">{TIPO_PROJETO_LABEL[projetoDetalhe.TIPO_PROJETO] || projetoDetalhe.TIPO_PROJETO || "Projeto"}</span>
                    {Boolean(projetoDetalhe.CADASTRO_PROVISORIO) && <span className="tag danger">Cadastro provisório</span>}
                    {numeroOuZero(projetoDetalhe.sessoesAtivas?.length) > 0 && <span className="tag ok">Em execução agora</span>}
                    {bloqueiosAbertos.length > 0 && <span className="tag warning">{bloqueiosAbertos.length} bloqueio(s)</span>}
                  </div>
                  <h2>{projetoDetalhe.TITULO}</h2>
                  <p>{projetoDetalhe.CODIGO || `Projeto #${projetoDetalhe.ID_PROJETO}`} • {STATUS_PROJETO_LABEL[projetoDetalhe.STATUS] || projetoDetalhe.STATUS}</p>
                </div>
                <button className="btn-close" onClick={fecharProjeto}>Fechar</button>
              </div>

              <div className="projeto-tabs" role="tablist">
                {ABAS_PROJETO.map(([id, label]) => (
                  <button key={id} type="button" className={abaProjeto === id ? "active" : ""} onClick={() => setAbaProjeto(id)}>
                    {label}
                    {id === "equipe" && <span>{participantesAtivos.length}</span>}
                    {id === "tarefas" && <span>{projetoDetalhe.tarefas?.length || 0}</span>}
                    {id === "bloqueios" && <span>{bloqueiosAbertos.length}</span>}
                  </button>
                ))}
              </div>

              <div className="projeto-modal-content">
                {loadingDetalhe && <EmptyState>Atualizando dados do projeto...</EmptyState>}

                {abaProjeto === "visao" && (
                  <div className="projeto-tab-panel">
                    <div className="projeto-info projeto-info-collab">
                      <div><span>Prioridade</span><strong>{projetoDetalhe.PRIORIDADE || "-"}</strong></div>
                      <div><span>Progresso</span><strong>{numeroOuZero(projetoDetalhe.PROGRESSO)}%</strong></div>
                      <div><span>Prazo</span><strong>{formatarData(projetoDetalhe.DT_PREVISTA)}</strong></div>
                      <div><span>Responsável principal</span><strong>{obterNomeFuncionario(responsavelPrincipal?.ID_DEV)}</strong></div>
                      <div><span>Participantes</span><strong>{participantesAtivos.length}</strong></div>
                      <div><span>Sessões ativas</span><strong>{projetoDetalhe.sessoesAtivas?.length || 0}</strong></div>
                      <div><span>Bloqueios abertos</span><strong>{bloqueiosAbertos.length}</strong></div>
                      <div><span>Gestor</span><strong>{obterNomeFuncionario(projetoDetalhe.GESTOR_PROJETO_ID)}</strong></div>
                    </div>

                    <div className="projeto-management-actions">
                      {Boolean(projetoDetalhe.CADASTRO_PROVISORIO) && (
                        <button className="btn-warning" disabled={processandoProjeto} onClick={formalizarProjetoProvisorio}>
                          Formalizar incidente
                        </button>
                      )}
                      {Number(projetoDetalhe.GESTOR_PROJETO_ID || 0) !== Number(gestorId || 0) && gestorId && (
                        <button className="btn-outline" disabled={processandoProjeto} onClick={assumirGestaoProjeto}>
                          Assumir gestão
                        </button>
                      )}
                    </div>

                    {projetoDetalhe.sessoesAtivas?.length > 0 && (
                      <section className="projeto-section">
                        <div className="section-heading">
                          <div><h3>Trabalhando agora</h3><p>Sessões atualmente abertas neste projeto.</p></div>
                        </div>
                        <div className="active-session-grid">
                          {projetoDetalhe.sessoesAtivas.map((sessao) => (
                            <div key={sessao.ID_SESSAO} className="active-session-card">
                              <div>
                                <strong>{obterNomeFuncionario(sessao.ID_DEV)}</strong>
                                <span>{sessao.TAREFA_TITULO || "Atividade geral do projeto"}</span>
                              </div>
                              <time>{formatarDuracao(duracaoSessao(sessao, agora))}</time>
                            </div>
                          ))}
                        </div>
                      </section>
                    )}

                    <section className="projeto-section descricao-projeto">
                      <div className="section-heading">
                        <div><h3>Descrição / escopo</h3><p>Contexto consolidado da entrega.</p></div>
                      </div>
                      <pre>{projetoDetalhe.DESCRICAO || "-"}</pre>
                    </section>

                    <section className="projeto-section projeto-meta-grid">
                      <div><span>Criação</span><strong>{formatarDataHora(projetoDetalhe.CREATED_AT)}</strong></div>
                      <div><span>Início</span><strong>{formatarData(projetoDetalhe.DT_INICIO)}</strong></div>
                      <div><span>Chamado de origem</span><strong>{projetoDetalhe.ID_CHAMADO_ORIGEM ? `#${projetoDetalhe.ID_CHAMADO_ORIGEM}` : "Projeto interno"}</strong></div>
                      <div><span>Solicitante da interrupção</span><strong>{obterNomeFuncionario(projetoDetalhe.SOLICITANTE_INTERRUPCAO_ID)}</strong></div>
                    </section>
                  </div>
                )}

                {abaProjeto === "equipe" && (
                  <div className="projeto-tab-panel">
                    <section className="projeto-section">
                      <div className="section-heading">
                        <div><h3>Adicionar participante</h3><p>Inclua backend, frontend, QA ou apoio sem criar outro projeto.</p></div>
                      </div>

                      <div className="projeto-form-grid participante-form">
                        <div className="field">
                          <label>Setor</label>
                          <select value={formParticipante.setor} onChange={(e) => {
                            const setor = e.target.value;
                            setFormParticipante((prev) => ({ ...prev, setor, devId: "" }));
                            carregarFuncionariosParticipantePorSetor(setor);
                          }}>
                            <option value="">Selecione</option>
                            {cargos.map((c) => <option key={c} value={c}>{c}</option>)}
                          </select>
                        </div>
                        <div className="field">
                          <label>Funcionário</label>
                          <select value={formParticipante.devId} disabled={!formParticipante.setor || loadingFuncionariosParticipante} onChange={(e) => setFormParticipante((prev) => ({ ...prev, devId: e.target.value }))}>
                            <option value="">{loadingFuncionariosParticipante ? "Carregando..." : "Selecione"}</option>
                            {funcionariosParticipante.map((f) => <option key={f.id} value={f.id}>{f.nome}</option>)}
                          </select>
                        </div>
                        <div className="field">
                          <label>Papel</label>
                          <select value={formParticipante.papel} onChange={(e) => setFormParticipante((prev) => ({ ...prev, papel: e.target.value }))}>
                            {PAPEIS.map((papel) => <option key={papel} value={papel}>{PAPEL_LABEL[papel]}</option>)}
                          </select>
                        </div>
                        <label className="check-field"><input type="checkbox" checked={formParticipante.responsavelPrincipal} onChange={(e) => setFormParticipante((prev) => ({ ...prev, responsavelPrincipal: e.target.checked }))} /> Responsável principal</label>
                        <label className="check-field"><input type="checkbox" checked={formParticipante.podeMovimentar} onChange={(e) => setFormParticipante((prev) => ({ ...prev, podeMovimentar: e.target.checked }))} /> Pode movimentar</label>
                        <div className="field field-wide">
                          <label>Justificativa</label>
                          <input value={formParticipante.justificativa} onChange={(e) => setFormParticipante((prev) => ({ ...prev, justificativa: e.target.value }))} placeholder="Ex: Responsável pelo frontend desta entrega" />
                        </div>
                        <div className="form-submit-line">
                          <button className="btn-primary" disabled={processandoProjeto} onClick={adicionarParticipanteProjeto}>Adicionar participante</button>
                        </div>
                      </div>
                    </section>

                    <section className="projeto-section">
                      <div className="section-heading">
                        <div><h3>Equipe do projeto</h3><p>Responsabilidade individual sem quebrar a visão única da entrega.</p></div>
                      </div>

                      <div className="team-management-list">
                        {participantesAtivos.length === 0 && <EmptyState>Nenhum participante ativo.</EmptyState>}
                        {participantesAtivos.map((participante) => (
                          <div key={participante.ID_ATRIBUICAO || participante.ID_DEV} className="team-management-row">
                            <div className="member-identity">
                              <strong>{obterNomeFuncionario(participante.ID_DEV)}</strong>
                              <div>
                                {Boolean(participante.RESPONSAVEL_PRINCIPAL) && <span className="tag ok">Principal</span>}
                                {Boolean(participante.TRABALHANDO_AGORA) && <span className="tag info">Trabalhando agora</span>}
                                {Boolean(participante.FOCUS_ATIVO) && <span className="tag warning">Foco</span>}
                              </div>
                            </div>
                            <select value={participante.PAPEL || "DESENVOLVEDOR"} disabled={processandoProjeto} onChange={(e) => atualizarParticipanteProjeto(participante.ID_DEV, { papel: e.target.value }, "Papel do participante atualizado.")}>
                              {PAPEIS.map((papel) => <option key={papel} value={papel}>{PAPEL_LABEL[papel]}</option>)}
                            </select>
                            <label className="compact-check"><input type="checkbox" checked={Boolean(participante.PODE_MOVIMENTAR)} disabled={processandoProjeto} onChange={(e) => atualizarParticipanteProjeto(participante.ID_DEV, { podeMovimentar: e.target.checked }, "Permissão do participante atualizada.")} /> Movimentar</label>
                            <div className="member-actions">
                              {!Boolean(participante.RESPONSAVEL_PRINCIPAL) && <button className="btn-outline" disabled={processandoProjeto} onClick={() => atualizarParticipanteProjeto(participante.ID_DEV, { responsavelPrincipal: true, papel: "RESPONSAVEL_PRINCIPAL" }, "Responsável principal alterado.")}>Tornar principal</button>}
                              <button className="btn-danger-outline" disabled={processandoProjeto} onClick={() => removerParticipanteProjeto(participante)}>Remover</button>
                            </div>
                          </div>
                        ))}
                      </div>
                    </section>
                  </div>
                )}

                {abaProjeto === "tarefas" && (
                  <div className="projeto-tab-panel">
                    <section className="projeto-section">
                      <div className="section-heading">
                        <div><h3>Nova tarefa</h3><p>Divida o projeto em etapas com um responsável individual.</p></div>
                      </div>
                      <div className="projeto-form-grid tarefa-form">
                        <div className="field field-wide"><label>Título</label><input value={formTarefa.titulo} onChange={(e) => setFormTarefa((prev) => ({ ...prev, titulo: e.target.value }))} placeholder="Ex: Implementar endpoints do backend" /></div>
                        <div className="field"><label>Responsável</label><select value={formTarefa.responsavelId} onChange={(e) => setFormTarefa((prev) => ({ ...prev, responsavelId: e.target.value }))}><option value="">Sem responsável</option>{participantesAtivos.map((p) => <option key={p.ID_DEV} value={p.ID_DEV}>{obterNomeFuncionario(p.ID_DEV)}</option>)}</select></div>
                        <div className="field"><label>Estimativa (h)</label><input type="number" min="0" step="0.25" value={formTarefa.estimativaH} onChange={(e) => setFormTarefa((prev) => ({ ...prev, estimativaH: e.target.value }))} /></div>
                        <div className="field"><label>Prazo</label><input type="date" value={formTarefa.dtPrevista} onChange={(e) => setFormTarefa((prev) => ({ ...prev, dtPrevista: e.target.value }))} /></div>
                        <div className="field field-full"><label>Descrição</label><textarea rows={3} value={formTarefa.descricao} onChange={(e) => setFormTarefa((prev) => ({ ...prev, descricao: e.target.value }))} /></div>
                        <div className="form-submit-line"><button className="btn-primary" disabled={processandoProjeto} onClick={criarTarefaProjeto}>Criar tarefa</button></div>
                      </div>
                    </section>

                    <section className="projeto-section">
                      <div className="section-heading"><div><h3>Tarefas do projeto</h3><p>Acompanhe responsabilidade, prazo, estimativa e horas gastas.</p></div></div>
                      <div className="task-management-list">
                        {(projetoDetalhe.tarefas || []).length === 0 && <EmptyState>Nenhuma tarefa cadastrada.</EmptyState>}
                        {(projetoDetalhe.tarefas || []).map((tarefa) => (
                          <div key={tarefa.ID_TAREFA} className={`task-management-card ${tarefa.STATUS === "CONCLUIDO" ? "done" : ""}`}>
                            <div className="task-card-head">
                              <div><strong>{tarefa.TITULO}</strong><span>#{tarefa.ID_TAREFA} • {formatarData(tarefa.DT_PREVISTA)}</span></div>
                              <StatusProjeto status={tarefa.STATUS} />
                            </div>
                            {tarefa.DESCRICAO && <p>{tarefa.DESCRICAO}</p>}
                            <div className="task-controls">
                              <div className="field"><label>Status</label><select value={tarefa.STATUS || "PENDENTE"} disabled={processandoProjeto} onChange={(e) => atualizarTarefaProjeto(tarefa.ID_TAREFA, { status: e.target.value }, "Status da tarefa atualizado.")}>{STATUS_TAREFA.map((status) => <option key={status} value={status}>{STATUS_PROJETO_LABEL[status] || status}</option>)}</select></div>
                              <div className="field"><label>Responsável</label><select value={tarefa.RESPONSAVEL_ID || ""} disabled={processandoProjeto} onChange={(e) => atualizarTarefaProjeto(tarefa.ID_TAREFA, { responsavelId: Number(e.target.value) || null }, "Responsável da tarefa atualizado.")}><option value="">Sem responsável</option>{participantesAtivos.map((p) => <option key={p.ID_DEV} value={p.ID_DEV}>{obterNomeFuncionario(p.ID_DEV)}</option>)}</select></div>
                              <div className="task-hours"><span>Estimativa</span><strong>{numeroOuZero(tarefa.ESTIMATIVA_H).toFixed(2)}h</strong></div>
                              <div className="task-hours"><span>Apontado</span><strong>{numeroOuZero(tarefa.GASTO_H).toFixed(2)}h</strong></div>
                              {tarefa.STATUS !== "CONCLUIDO" && <button className="btn-outline" disabled={processandoProjeto} onClick={() => atualizarTarefaProjeto(tarefa.ID_TAREFA, { status: "CONCLUIDO", dtConclusao: new Date().toISOString() }, "Tarefa concluída.")}>Concluir</button>}
                            </div>
                          </div>
                        ))}
                      </div>
                    </section>
                  </div>
                )}

                {abaProjeto === "bloqueios" && (
                  <div className="projeto-tab-panel">
                    <section className="projeto-section">
                      <div className="section-heading"><div><h3>Registrar bloqueio</h3><p>Defina o motivo, a próxima ação, o responsável e a data de cobrança.</p></div></div>
                      <div className="projeto-form-grid bloqueio-form">
                        <div className="field"><label>Tipo</label><select value={formBloqueio.tipoBloqueio} onChange={(e) => setFormBloqueio((prev) => ({ ...prev, tipoBloqueio: e.target.value }))}>{TIPOS_BLOQUEIO.map((tipo) => <option key={tipo} value={tipo}>{TIPO_BLOQUEIO_LABEL[tipo]}</option>)}</select></div>
                        <div className="field"><label>Tarefa</label><select value={formBloqueio.idTarefa} onChange={(e) => setFormBloqueio((prev) => ({ ...prev, idTarefa: e.target.value }))}><option value="">Projeto inteiro</option>{(projetoDetalhe.tarefas || []).map((t) => <option key={t.ID_TAREFA} value={t.ID_TAREFA}>{t.TITULO}</option>)}</select></div>
                        <div className="field"><label>Responsável pela resolução</label><select value={formBloqueio.responsavelResolucaoId} onChange={(e) => setFormBloqueio((prev) => ({ ...prev, responsavelResolucaoId: e.target.value }))}><option value="">Não definido</option>{participantesAtivos.map((p) => <option key={p.ID_DEV} value={p.ID_DEV}>{obterNomeFuncionario(p.ID_DEV)}</option>)}</select></div>
                        <div className="field"><label>Próxima revisão</label><input type="date" value={formBloqueio.dtProximaRevisao} onChange={(e) => setFormBloqueio((prev) => ({ ...prev, dtProximaRevisao: e.target.value }))} /></div>
                        <div className="field field-full"><label>Motivo</label><textarea rows={3} value={formBloqueio.motivo} onChange={(e) => setFormBloqueio((prev) => ({ ...prev, motivo: e.target.value }))} placeholder="O que impede a continuidade?" /></div>
                        <div className="field field-full"><label>Próxima ação</label><textarea rows={2} value={formBloqueio.proximaAcao} onChange={(e) => setFormBloqueio((prev) => ({ ...prev, proximaAcao: e.target.value }))} placeholder="Quem deve fazer o quê para destravar?" /></div>
                        <div className="form-submit-line"><button className="btn-warning" disabled={processandoProjeto} onClick={criarBloqueioProjeto}>Registrar bloqueio</button></div>
                      </div>
                    </section>

                    <section className="projeto-section">
                      <div className="section-heading"><div><h3>Histórico de bloqueios</h3><p>Bloqueios abertos aparecem primeiro e permanecem no histórico após a resolução.</p></div></div>
                      <div className="block-management-list">
                        {(projetoDetalhe.bloqueios || []).length === 0 && <EmptyState>Nenhum bloqueio registrado.</EmptyState>}
                        {(projetoDetalhe.bloqueios || []).map((bloqueio) => (
                          <div key={bloqueio.ID_BLOQUEIO} className={`block-management-card ${bloqueio.STATUS_BLOQUEIO === "ABERTO" ? "open" : "resolved"}`}>
                            <div className="block-card-head">
                              <div><strong>{TIPO_BLOQUEIO_LABEL[bloqueio.TIPO_BLOQUEIO] || bloqueio.TIPO_BLOQUEIO}</strong><span>{bloqueio.TAREFA_TITULO || "Projeto inteiro"}</span></div>
                              <span className={`tag ${bloqueio.STATUS_BLOQUEIO === "ABERTO" ? "warning" : "ok"}`}>{bloqueio.STATUS_BLOQUEIO}</span>
                            </div>
                            <p>{bloqueio.MOTIVO}</p>
                            <div className="block-meta">
                              <span>Responsável: {obterNomeFuncionario(bloqueio.RESPONSAVEL_RESOLUCAO_ID)}</span>
                              <span>Revisão: {formatarData(bloqueio.DT_PROXIMA_REVISAO)}</span>
                              <span>Criado: {formatarDataHora(bloqueio.CREATED_AT)}</span>
                            </div>
                            {bloqueio.PROXIMA_ACAO && <div className="next-action"><b>Próxima ação:</b> {bloqueio.PROXIMA_ACAO}</div>}
                            {bloqueio.STATUS_BLOQUEIO === "ABERTO" ? (
                              <div className="resolve-line"><input value={solucoesBloqueio[bloqueio.ID_BLOQUEIO] || ""} onChange={(e) => setSolucoesBloqueio((prev) => ({ ...prev, [bloqueio.ID_BLOQUEIO]: e.target.value }))} placeholder="Informe como o bloqueio foi resolvido" /><button className="btn-primary" disabled={processandoProjeto} onClick={() => resolverBloqueioProjeto(bloqueio)}>Resolver</button></div>
                            ) : (
                              <div className="resolved-solution"><b>Solução:</b> {bloqueio.SOLUCAO || "-"}</div>
                            )}
                          </div>
                        ))}
                      </div>
                    </section>
                  </div>
                )}

                {abaProjeto === "tempo" && (
                  <div className="projeto-tab-panel">
                    <section className="projeto-section">
                      <div className="section-heading"><div><h3>Sessões de trabalho</h3><p>Tempo real investido por desenvolvedor e por tarefa.</p></div></div>
                      <div className="time-summary-grid">
                        <div><span>Total de sessões</span><strong>{sessoesProjeto.length}</strong></div>
                        <div><span>Sessões ativas</span><strong>{sessoesProjeto.filter((s) => !s.DT_FIM && s.STATUS_SESSAO === "ATIVA").length}</strong></div>
                        <div><span>Tempo acumulado</span><strong>{formatarDuracao(sessoesProjeto.reduce((acc, s) => acc + duracaoSessao(s, agora), 0))}</strong></div>
                        <div><span>Participantes com horas</span><strong>{new Set(sessoesProjeto.map((s) => s.ID_DEV)).size}</strong></div>
                      </div>

                      <div className="session-table-wrap">
                        <table className="session-table">
                          <thead><tr><th>Desenvolvedor</th><th>Tarefa</th><th>Início</th><th>Fim</th><th>Status</th><th>Duração</th></tr></thead>
                          <tbody>
                            {sessoesProjeto.length === 0 && <tr><td colSpan={6}><EmptyState>Nenhuma sessão registrada.</EmptyState></td></tr>}
                            {sessoesProjeto.map((sessao) => (
                              <tr key={sessao.ID_SESSAO}>
                                <td>{obterNomeFuncionario(sessao.ID_DEV)}</td>
                                <td>{sessao.TAREFA_TITULO || "Atividade geral"}</td>
                                <td>{formatarDataHora(sessao.DT_INICIO)}</td>
                                <td>{formatarDataHora(sessao.DT_FIM)}</td>
                                <td><span className={`tag ${sessao.STATUS_SESSAO === "ATIVA" ? "ok" : sessao.STATUS_SESSAO === "INTERROMPIDA" ? "warning" : "info"}`}>{sessao.STATUS_SESSAO}</span></td>
                                <td className="mono-time">{formatarDuracao(duracaoSessao(sessao, agora))}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </section>
                  </div>
                )}

                {abaProjeto === "apontamentos" && (
                  <div className="projeto-tab-panel">
                    <section className="comentarios-box projeto-section">
                      <div className="section-heading"><div><h3>Apontamentos de gestão</h3><p>Registre cobranças, decisões, alinhamentos e próximos passos.</p></div></div>
                      <textarea rows={4} value={comentarioTexto} onChange={(e) => setComentarioTexto(e.target.value)} placeholder="Registre aqui o acompanhamento, cobrança ou decisão sobre este projeto..." />
                      <button className="btn-primary" disabled={postandoComentario} onClick={incluirComentarioProjeto}>{postandoComentario ? "Salvando..." : "Registrar apontamento"}</button>
                      <div className="comentarios-list">
                        {comentariosProjeto.length === 0 && <EmptyState>Nenhum apontamento registrado.</EmptyState>}
                        {comentariosProjeto.map((c) => (
                          <div key={c.ID_COMENTARIO} className="comentario-item">
                            <div><strong>{obterNomeFuncionario(c.AUTOR_ID)}</strong><span>{formatarDataHora(c.CREATED_AT)}</span></div>
                            <p>{c.TEXTO}</p>
                          </div>
                        ))}
                      </div>
                    </section>
                  </div>
                )}
              </div>

              <div className="projeto-modal-footer">
                <span>{processandoProjeto ? "Processando alteração..." : `Atualizado em ${formatarDataHora(projetoDetalhe.UPDATED_AT)}`}</span>
                <button className="btn-secondary" onClick={fecharProjeto}>Fechar</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </MainLayout>
  );
}
